module.exports = __webpack_public_path__ + "static/img/1_3_1.000b5d9d.png";